import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { MonitorPlay, Download, Play, Tv, Loader2 } from "lucide-react";

export default function DownloadPage() {
  const [s, setS] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/settings").then(({ data }) => setS(data)); }, []);

  if (!s) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 text-red-500 animate-spin" /></div>;

  const steps = s.download_instructions
    ? s.download_instructions.split("\n").filter(Boolean)
    : [
        "On your Fire TV / Android TV, install the free 'Downloader' app from the store.",
        "Open Downloader and enter the APK URL shown above, then press Go.",
        "Wait for the download to finish and select Install.",
        "Open IBO STREAM, note your MAC Address and Device Key.",
        "On this website, go to 'Manage Device', sign in with your MAC + Device Key and add your playlist.",
      ];

  return (
    <div className="min-h-screen relative">
      <img src="https://images.pexels.com/photos/5721908/pexels-photo-5721908.jpeg" alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/85" />
      <div className="relative z-10">
        <header className="flex items-center justify-between px-6 md:px-12 h-16">
          <button onClick={() => navigate("/")} className="flex items-center gap-2.5">
            <div className="p-1.5 rounded-lg bg-red-600"><MonitorPlay className="w-4 h-4 text-white" /></div>
            <span className="font-head font-bold">IBO<span className="text-red-500">STREAM</span></span>
          </button>
          <button onClick={() => navigate("/manage")} className="text-sm text-zinc-400 hover:text-white transition-colors">Manage Device</button>
        </header>

        <div className="max-w-4xl mx-auto px-6 py-14 fade-up">
          <div className="flex items-center gap-2 mb-3"><Tv className="w-5 h-5 text-red-500" /><span className="text-xs uppercase tracking-[0.25em] text-red-500 font-semibold">Android TV · Google TV · Fire TV</span></div>
          <h1 className="font-head text-4xl md:text-5xl font-bold tracking-tighter">Download the App</h1>
          <p className="text-zinc-400 text-lg mt-4 max-w-xl">Install IBO STREAM on your TV and start your 7-day free trial. Works with your TV remote.</p>

          <div className="flex flex-wrap gap-4 mt-8">
            {s.play_store_url ? (
              <a data-testid="play-store-btn" href={s.play_store_url} target="_blank" rel="noreferrer"
                className="flex items-center gap-2.5 px-7 py-3.5 rounded-full bg-white text-black font-semibold hover:bg-zinc-200 transition-colors">
                <Play className="w-5 h-5 fill-black" /> Google Play
              </a>
            ) : (
              <span className="flex items-center gap-2.5 px-7 py-3.5 rounded-full bg-zinc-800 text-zinc-500 font-semibold cursor-not-allowed">
                <Play className="w-5 h-5" /> Google Play (coming soon)
              </span>
            )}
            {s.apk_url ? (
              <a data-testid="apk-download-btn" href={s.apk_url} target="_blank" rel="noreferrer"
                className="flex items-center gap-2.5 px-7 py-3.5 rounded-full bg-red-600 hover:bg-red-500 text-white font-semibold transition-colors">
                <Download className="w-5 h-5" /> Download APK
              </a>
            ) : (
              <span className="flex items-center gap-2.5 px-7 py-3.5 rounded-full bg-zinc-800 text-zinc-500 font-semibold cursor-not-allowed">
                <Download className="w-5 h-5" /> APK (coming soon)
              </span>
            )}
          </div>
          {s.apk_url && <p className="mt-3 text-sm text-zinc-500 font-mono-data break-all">APK URL: {s.apk_url}</p>}

          <div className="glass rounded-2xl p-8 mt-12 max-w-2xl">
            <h2 className="font-head text-2xl font-semibold mb-5">Install with Downloader (Fire TV / Android TV)</h2>
            <ol className="space-y-4">
              {steps.map((t, i) => (
                <li key={i} className="flex gap-4">
                  <span className="shrink-0 w-7 h-7 rounded-full bg-red-600 text-white text-sm font-bold flex items-center justify-center">{i + 1}</span>
                  <span className="text-zinc-300 pt-0.5">{t}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}
